var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "channel-distribution"
  }, [_c('div', {
    staticClass: "filter-bar"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.queryData.reportState,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "reportState", $$v);
      },
      expression: "queryData.reportState"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("报备排行")]), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("带看排行")])], 1), _c('div', [_c('el-date-picker', {
    staticClass: "mr10",
    attrs: {
      "type": "daterange",
      "align": "right",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": "",
      "picker-options": _vm.pickerOptions,
      "size": "medium"
    },
    on: {
      "change": _vm.onDateRangeChange
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c('el-select', {
    staticClass: "select",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "报备项目",
      "size": "medium"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.queryData.estateId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "estateId", $$v);
      },
      expression: "queryData.estateId"
    }
  }, _vm._l(_vm.estateList, function (item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1)], 1)], 1), _c('el-table', {
    staticClass: "mt15",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "align": "center",
      "width": "65"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "渠道名称"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [row.count ? _c('span', [_vm._v(" " + _vm._s(row.count) + "组")]) : _c('span', [_vm._v("-")])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "占比",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_c('span', [_vm._v(" " + _vm._s(row.proportion || "-"))])];
      }
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }